// routes
import AppRouter from "./AppRoutes";
import AuthRouter from "./AuthRouter";
// theme
import ThemeProvider from "./theme";
// components
import React, { useEffect } from "react";
import { CircularProgress, Box } from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux";
import ErrorBoundary from "./components/common/ErrorBoundary";

import _ from "lodash";

// ----------------------------------------------------------------------

export default function App() {
  const { isLoading } = useSelector((state) => state);

  return (
    <ErrorBoundary>
      <ThemeProvider>
        {isLoading && (
          <Box sx={{ display: "flex" }}>
            <CircularProgress />
          </Box>
        )}
        {/* <Notification /> */}
        <AppRouter />
        <AuthRouter />
      </ThemeProvider>
    </ErrorBoundary>
  );
}
